"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(s) {
  return s;
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/styles/createStyles.js
// module id = 299
// module chunks = 0